import React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { accountsURL, accountURL } from '@admin/config/routes';
import { Account, Customer } from '@admin/schema';

export const AccountBreadcrumbs: React.FC<{
  account: Pick<Account, 'id' | 'number'> & {
    customer: Pick<Customer, 'name'>;
  };
  newItem?: string;
}> = ({ account, newItem }) => (
  <Breadcrumb>
    <Breadcrumb.Item>
      <NavLink to={accountsURL()}>Accounts</NavLink>
    </Breadcrumb.Item>
    <Breadcrumb.Item>
      <NavLink to={accountURL({ id: account.id })}>{`#${account.number} (${account.customer.name})`}</NavLink>
    </Breadcrumb.Item>
    {newItem && <Breadcrumb.Item active>{newItem}</Breadcrumb.Item>}
  </Breadcrumb>
);
